import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  dropDownOptionsShape,
} from '../../data-structure/v-f-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/sub-components/drop-down-options.css';
import {
  STANDARD_DROPDOWN,
  CATEGORISED_DROPDOWN,
  CATEGORISED_TYPEAHEAD,
} from './templates/dropdown-templates';
import { StandardDropDownList } from './templates/standard/standard-drop-down-list';
import { CategorisedDropDownList } from './templates/categorised/categorised-drop-down-list';
import 'AppSrc/core/style/components/form/form-base-components/templated-option-button/templated-option-button.css';


const componentMap = {
  // // some components don't have a specific head and so just use the standard one
  [STANDARD_DROPDOWN]: StandardDropDownList,
  [CATEGORISED_DROPDOWN]: CategorisedDropDownList,
  [CATEGORISED_TYPEAHEAD]: CategorisedDropDownList,
};

const getListComponent = (optionTemplate) => {

  const ListComponent = componentMap[optionTemplate];

  if (!ListComponent) {
    console.warn(`FALLING BACK TO ${STANDARD_DROPDOWN} DROPDOWN AS UNABLE TO FIND A TEMPLATE FOR ${optionTemplate}`);
    return componentMap[STANDARD_DROPDOWN];
  }

  return ListComponent;
};



class DropDownOptions extends PureComponent {
  constructor(props) {
    super(props);
    this.updateValue = this.updateValue.bind(this);
  }

  updateValue(value) {
    this.props.updateValue(value);
  }

  render() {
    const {
      optionTemplate,
      displayOptions,
    } = this.props;

    const ListComponent = getListComponent(optionTemplate);


    return (
      <ul
        className="dropdown-items"
      >
        <ListComponent
          onClick={this.updateValue}
          displayOptions={displayOptions}
          optionTemplate={optionTemplate}
        />
      </ul>
    );
  }
}

DropDownOptions.propTypes = {
  updateValue: PropTypes.func,
  optionTemplate: PropTypes.string,
  displayOptions: PropTypes.arrayOf(dropDownOptionsShape),

};



export { DropDownOptions };

